export function IdInput(id: number) {
  return <input readOnly hidden name="id" value={id} />;
}
